/* PD Sociale medier — reel cards.
   1) Videos carry NO src until they are actually on screen. Measured on theme 0.2 (2026-09-17): three
      autoplaying 1080p reels 1,700 px below the fold were, whenever autoplay was blocked (iOS Low Power
      Mode, Data Saver), loaded-but-paused — three suspended media streams pinned on the page's HTTP/3
      connection, and the NEXT navigation waited ~12 s for its first byte (5 of 9 product taps from the
      search overlay stalled; 0 over HTTP/2; 0 on the live theme, which has no reels). Attaching the
      source only while a reel is ≥60% visible and detaching it when it leaves means no idle stream is
      ever left on the connection. Verified: 0/8 stalls with this behaviour vs 4/8 without, interleaved.
   2) Speaker toggle per card — the visible reels play muted; the button unmutes ONE card (the others go
      quiet), a second click mutes it again. Re-runs after a soft navigation (pd:navigated) and in the
      theme editor (shopify:section:load). */
(function () {
  var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  // Shopify keeps a 480p rendition of every reel on the CDN (4 MB vs 17 MB for the 1080p upload)
  // but does NOT list it in `video.sources`, so Liquid cannot pick it. Derive the URL from the
  // 1080p one and fall back to the original if that rendition ever 404s.
  var SD = function (u) { return u.replace(/HD-1080p-[\d.]+Mbps/, "SD-480p-1.5Mbps"); };
  function attach(v) {
    if (v.getAttribute("src") || !v.dataset.pdReelSrc) return;
    var orig = v.dataset.pdReelSrc, sd = SD(orig);
    if (sd !== orig && !v.dataset.pdReelSdFailed) {
      v.addEventListener("error", function onErr() {
        v.removeEventListener("error", onErr);
        if (v.getAttribute("src") === sd) { v.dataset.pdReelSdFailed = "1"; v.src = orig; var p = v.play(); if (p && p.catch) p.catch(function () {}); }
      });
      v.src = sd;
    } else {
      v.src = orig;
    }
  }
  function detach(v) {
    if (!v.getAttribute("src")) return;
    try { v.pause(); } catch (e) {}
    v.removeAttribute("src");
    try { v.load(); } catch (e) {} // releases the media stream, not just the element state
  }
  function play(v) { attach(v); var p = v.play(); if (p && p.catch) p.catch(function () {}); }

  function init(root) {
    if (root.dataset.pdReelsInit) return; root.dataset.pdReelsInit = "1";
    var videos = Array.prototype.slice.call(root.querySelectorAll("video[data-pd-reel-src]"));

    if ("IntersectionObserver" in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.intersectionRatio >= 0.6) { if (!reduce) play(e.target); }
          else detach(e.target);
        });
      }, { threshold: [0, 0.6] });
      videos.forEach(function (v) { io.observe(v); });
    }
    // Leaving the page: drop every stream now rather than letting the navigation cancel them.
    window.addEventListener("pagehide", function () { videos.forEach(detach); });

    root.addEventListener("click", function (e) {
      var btn = e.target.closest("[data-pd-reels-sound]"); if (!btn || !root.contains(btn)) return;
      e.preventDefault();
      var item = btn.closest(".pd-reels__item"), video = item && item.querySelector("video"); if (!video) return;
      var turnOn = video.muted;
      root.querySelectorAll(".pd-reels__item").forEach(function (o) {
        var v = o.querySelector("video"), b = o.querySelector("[data-pd-reels-sound]"); if (!v || !b) return;
        var on = (o === item) && turnOn;
        v.muted = !on;
        b.classList.toggle("is-on", on); b.setAttribute("aria-pressed", on ? "true" : "false"); b.setAttribute("aria-label", on ? (b.dataset.labelOff || "") : (b.dataset.labelOn || ""));
      });
      if (turnOn) { video.volume = 1; play(video); }
    });
  }
  function all(scope) { (scope || document).querySelectorAll("[data-pd-reels]").forEach(init); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", function () { all(); }); else all();
  document.addEventListener("pd:navigated", function () { all(); });
  document.addEventListener("shopify:section:load", function (e) { all(e.target); });
})();
